<template>
  <div>
    <v-row>
      <v-col cols="12" md='6'>
        <v-datetime-picker
          locale="zh-cn"
          clear-text='清空'
          ok-text='确定'
          :text-field-props='filedProps'
          :date-picker-props="startDateProps"
          :time-picker-props='timeProps'
          :label="label[0]"
          v-model="startTime"
          @input='inputStartValue'
          >
          <template slot="dateIcon">
            <v-icon>mdi-calendar-range</v-icon>
          </template>
          <template slot="timeIcon">
            <v-icon>mdi-clock-outline</v-icon>
          </template>
        </v-datetime-picker>
      </v-col>
      <v-col cols="12" md='6'>
        <v-datetime-picker
          locale="zh-cn"
          clear-text='清空'
          ok-text='确定'
          :text-field-props='filedProps'
          :date-picker-props="endDateProps"
          :time-picker-props='timeProps'
          :label="label[1]"
          v-model="endTime"
          @input='inputEndValue'
          >
          <template slot="dateIcon">
            <v-icon>mdi-calendar-range</v-icon>
          </template>
          <template slot="timeIcon">
            <v-icon>mdi-clock-outline</v-icon>
          </template>
        </v-datetime-picker>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'MaterialTimeRangePicker',
    props: {
      value: {
        type: Array,
        default: () => ([])
      },
      label: {
        type: Array,
        default: () => ([
          '开始时间',
          '结束时间'
        ])
      },
      filedProps: {
        type: Object,
        default: () => ({
          outlined: true
        })
      }
    },
    data () {
      return {
        result: [ '', ''],
        startTime: this.value[0],
        endTime: this.value[1],
        startDateProps: {
          locale: 'zh-cn',
          max: '',
          min: ''
        },
        endDateProps: {
          locale: 'zh-cn',
          max: '',
          min: ''
        },
        timeProps: {
          locale: 'zh-cn',
          format: '24hr'
        },
      }
    },
    watch: {
    },
    methods: {
      inputStartValue (val) {
        if (val) {
          const start = this.$moment(val).format("YYYY-MM-DD HH:mm")
          this.result[0] = start
          this.endDateProps.min = start
        } else {
          this.result[0] = ''
          this.endDateProps.min = ''
        }
        this.$emit('input', this.result)
      },
      inputEndValue (val) {
        if (val) {
          const end = this.$moment(val).format("YYYY-MM-DD HH:mm")
          this.result[1] = end
          this.startDateProps.max = end
        } else {
          this.result[1] = ''
          this.startDateProps.max = ''
        }
        this.$emit('input', this.result)
      }
    }
  }
</script>
